import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShButton from '@/components/Helpers/ShButton';
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';

// @vue/component
export default {
  name: 'UsersListItem',

  components: {
    ShUserAvatar,
    ShButton,
    ShPopconfirm,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isNotAddedToCallwebPlatform() {
      return Object.keys(this.user.profile).length === 0;
    },
    isLoggedUser() {
      const loggedUser = this.$store.getters['authorization/user'];
      return this.user.users_uuid === loggedUser.user_uuid;
    },
  },

  methods: {
    handleEditUser() {
      this.$EventBus.$emit('SHOW_USER_PROFILE', { user: this.user, shouldRefreshList: true });
    },
    handleAddUserToCallweb() {
      this.$EventBus.$emit('AddInactiveUserToCallwebForm/SHOW_ADD_USER_TO_CALLWEB_FORM', this.user);
    },
    async handleDeleteUser() {
      await this.$store.dispatch('users/delete', { user_uuid: this.user.users_uuid });
      await this.$store.dispatch('users/getList');
    },
  },
};
